import type { Variant } from '@amplitude/experiment-js-client';

/**
 * Interprets an Experiment {@link Variant} as a boolean for simple on/off flags.
 */
export const variantToBoolean = (
  variant: Variant | undefined,
  defaultValue: boolean
): boolean => {
  const raw = variant?.value ?? variant?.key;
  if (raw === undefined || raw === '') {
    return defaultValue;
  }
  const s = String(raw).toLowerCase();
  if (
    s === 'true' ||
    s === 'on' ||
    s === 'treatment' ||
    s === '1' ||
    s === 'yes'
  ) {
    return true;
  }
  if (
    s === 'false' ||
    s === 'off' ||
    s === 'control' ||
    s === '0' ||
    s === 'no'
  ) {
    return false;
  }
  return defaultValue;
};
